import React, { useState, useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faTrash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { loadPassportData, savePassportData, setActiveQueueScheduler } from './translatedata';
import { uploadKindergartenCover, deleteKindergartenCover, base64ToFile } from './translatedata';
import { constr_uri } from '../../../../../services/apiClient';
import FileUploader from '../../../../../components/FileUpload/FileUploader';
import { employeeAPI } from '../Employee/actions';

import './cabinet-zdo-passport.css';

// Скоригуй шляхи імпортів (constr_uri, FileUploader) під структуру проекту

const ZDOPassport = ({kg_id}) => {
  const [passportData, setPassportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploadingCover, setUploadingCover] = useState(false);
  // Список активних працівників — для вибору директора зі списку замість
  // вільного текстового поля.
  const [employeesList, setEmployeesList] = useState([]);
  const [employeesLoading, setEmployeesLoading] = useState(false);

  useEffect(() => {
    if (!kg_id) return;
    setEmployeesLoading(true);
    employeeAPI.getActiveEmployees(kg_id)
      .then(list => setEmployeesList(list || []))
      .catch(error => {
        console.error('Помилка завантаження списку працівників:', error);
        setEmployeesList([]);
      })
      .finally(() => setEmployeesLoading(false));
  }, [kg_id]);


  const handleCloseQueue = async ()=>{
    const result = await setActiveQueueScheduler({kg_id, isOpen: passportData.isOpen});
    setPassportData({...passportData, isOpen: !passportData.isOpen});
  }

  const coverSrc = passportData && passportData.coverDocId && passportData.coverFileId
    ? constr_uri('docfile?doc_id=' + passportData.coverDocId + '&file_id=' + passportData.coverFileId)
    : null;

  const handleCoverPick = async (picked) => {
    var file = picked && picked[0];
    if (!file) return;

    setUploadingCover(true);
    try {
      var realFile = base64ToFile(file.file, file.name, file.type);
      var result = await uploadKindergartenCover(kg_id, realFile);
      setPassportData(prev => ({ ...prev, coverDocId: result.coverDocId, coverFileId: result.coverFileId }));
      toast.success('Обкладинку завантажено');
    } catch (err) {
      toast.error('Помилка завантаження обкладинки');
    } finally {
      setUploadingCover(false);
    }
  };

  const handleCoverDelete = async () => {
    try {
      await deleteKindergartenCover(kg_id);
      setPassportData(prev => ({ ...prev, coverFileId: null }));
    } catch (err) {
      toast.error('Помилка видалення обкладинки');
    }
  };

  // Загрузка данных при монтировании
  useEffect(() => {

    async function api() {
      setLoading(true);
      const data = await loadPassportData(kg_id);
      setPassportData(data);
      setLoading(false);
    }

    if(kg_id) api();

  }, [kg_id]);

  

  const handleSave = async () => {

    try {
      setSaving(true);
      const result = await savePassportData({kg_id, data:passportData});
      alert((result.data?.nModified && result.data?.nModified == 1) ? `Інформація збережена успішно` : `Вибачте, але виникла помилка під час збереження`);
      
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      alert('Помилка збереження даних');
    } finally {
      setSaving(false);
    }
  };

  const handleInputChange = (field, value) => {
    setPassportData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleWorkModeChange = (index, field, value) => {
    setPassportData(prev => ({
      ...prev,
      workModes: prev.workModes.map((mode, i) => 
        i === index ? { ...mode, [field]: value } : mode
      )
    }));
  };

  const handleWorkDayChange = (day, checked) => {
    setPassportData(prev => ({
      ...prev,
      workDays: {
        ...prev.workDays,
        [day]: checked
      }
    }));
  };


  if (loading) {
    return <div className="text-center p-4">Завантаження...</div>;
  }

  if (!passportData) {
    return <div className="text-center p-4">Помилка завантаження даних</div>;
  }


  return (
    <main className="passport-main-content passport-page">
      <div className="container-fluid">
        <div className="row">
          <div className="content-wrapper passport-content-wrapper">
            <div className="card card-body p-4">

              {/* ── Обкладинка садочка ── */}
              <h6 className="passport-section-title mb-3" style={{ marginTop: 0 }}>Обкладинка садочка</h6>
              <div className="row g-3" style={{ marginBottom: 8 }}>
                <div className="col-12">
                  {coverSrc ? (
                    <div style={{
                      width: '100%', maxWidth: 420, height: 220,
                      borderRadius: 12, overflow: 'hidden', position: 'relative',
                    }}>
                      <img src={coverSrc} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      <button
                        type="button"
                        onClick={handleCoverDelete}
                        style={{
                          position: 'absolute', top: 10, right: 10,
                          width: 34, height: 34, borderRadius: '50%',
                          background: 'rgba(0,0,0,0.55)', border: 'none', color: '#fff',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          cursor: 'pointer',
                        }}
                        title="Видалити обкладинку"
                      >
                        <FontAwesomeIcon icon={faTrash} style={{ fontSize: 13 }} />
                      </button>
                      {uploadingCover && (
                        <div style={{
                          position: 'absolute', inset: 0,
                          background: 'rgba(255,255,255,0.7)',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                          <Spinner animation="border" size="sm" variant="primary" />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ maxWidth: 420 }}>
                      <FileUploader
                        label=""
                        description="Фото для картки садочка на сторінці пошуку. JPG, PNG. Рекомендовано горизонтальне, до 8 МБ."
                        accept="image/*"
                        multiple={false}
                        maxCount={1}
                        maxSize={8 * 1024 * 1024}
                        value={[]}
                        onChange={handleCoverPick}
                        asBase64={true}
                        editable={!uploadingCover}
                        disabled={uploadingCover}
                      />
                      {uploadingCover && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, fontSize: 13, color: '#6b7280' }}>
                          <Spinner animation="border" size="sm" style={{ width: 14, height: 14 }} />
                          Завантаження...
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <hr className="passport-my-4" />

              <div className="row g-3 align-items-center">
                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="type">Тип</label>
                </div>
                <div className="passport-value-col">
                  <select 
                    id="type" 
                    className="form-select passport-form-select"
                    value={passportData.type}
                    onChange={(e) => handleInputChange('type', e.target.value)}
                  >
                    <option>Дошкільний підрозділ</option>
                    <option>ЗДО</option>
                    <option>Приватний ЗДО</option>
                  </select>
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="ownership">Власність</label>
                </div>
                <div className="passport-value-col">
                  <select 
                    id="ownership" 
                    className="form-select passport-form-select"
                    value={passportData.ownership}
                    onChange={(e) => handleInputChange('ownership', e.target.value)}
                  >
                    <option>Комунальний</option>
                    <option>Державний</option>
                    <option>Приватний</option>
                  </select>
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="specialization">Спеціалізація</label>
                </div>
                <div className="passport-value-col">
                  <select 
                    id="specialization" 
                    className="form-select passport-form-select"
                    value={passportData.specialization}
                    onChange={(e) => handleInputChange('specialization', e.target.value)}
                  >
                    <option>Без спеціалізації</option>
                    <option>Мовна</option>
                    <option>Інклюзивна</option>
                  </select>
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="extra">Додатково має</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="extra"
                    type="text"
                    className="form-control passport-form-control"
                    value={passportData.extra}
                    onChange={(e) => handleInputChange('extra', e.target.value)}
                  />
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="specifics">Тип закладу</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="specifics"
                    type="text"
                    className="form-control passport-form-control"
                    value={passportData.specifics}
                    onChange={(e) => handleInputChange('specifics', e.target.value)}
                  />
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="additionalServices">Додаткові сервіси</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="additionalServices"
                    type="text"
                    className="form-control passport-form-control"
                    value={passportData.additionalServices}
                    onChange={(e) => handleInputChange('additionalServices', e.target.value)}
                  />
                </div>
              </div>

              <hr className="passport-my-4" />

              <h6 className="passport-section-title mb-3">Контакти</h6>
              <div className="row g-3 align-items-center">
                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="address">Адреса</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="address"
                    type="text"
                    className="form-control passport-form-control"
                    value={passportData.address}
                    onChange={(e) => handleInputChange('address', e.target.value)}
                  />
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="district">Район</label>
                </div>
                <div className="passport-value-col">
                  <select 
                    id="district" 
                    className="form-select passport-form-select"
                    value={passportData.district}
                    onChange={(e) => handleInputChange('district', e.target.value)}
                  >
                    <option>Голосіївський</option>
                    <option>Дарницький</option>
                    <option>Дніпровський</option>
                    <option>Деснянський</option>
                    <option>Святошинський</option>
                    <option>Солом'янський</option>
                    <option>Оболонський</option>
                    <option>Печерський</option>
                    <option>Подільський</option>
                    <option>Шевченківський</option>
                  </select>
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="phone">Телефон</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="phone"
                    type="tel"
                    className="form-control passport-form-control"
                    value={passportData.phone}
                    onChange={(e) => handleInputChange('phone', e.target.value)}
                  />
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="email">Email</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="email"
                    type="email"
                    className="form-control passport-form-control"
                    value={passportData.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                  />
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="site">Сайт</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="site"
                    type="url"
                    className="form-control passport-form-control"
                    value={passportData.site}
                    onChange={(e) => handleInputChange('site', e.target.value)}
                  />
                </div>
              </div>

              <hr className="passport-my-4" />

              <h6 className="passport-section-title mb-3">Режим роботи</h6>
              <div className="row g-3 passport-work-schedule">
                <div className="col-md-4">
                  <label className="form-label passport-form-label" htmlFor="mode1">Режим роботи</label>
                  <div className="passport-stack-2">
                    {passportData.workModes.map((mode, index) => (
                      <select
                        key={index}
                        className="form-select passport-form-select"
                        value={mode.mode}
                        onChange={(e) => handleWorkModeChange(index, 'mode', e.target.value)}
                      >
                        <option>Повний 12-годинний день</option>
                        <option>Скорочений 10,5-годинний день</option>
                        <option>Короткотривалий</option>
                      </select>
                    ))}
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="form-label passport-form-label" htmlFor="start1">Початок роботи</label>
                  <div className="passport-stack-2">
                    {passportData.workModes.map((mode, index) => (
                      <input
                        key={index}
                        type="text"
                        className="form-control passport-form-control"
                        value={mode.start}
                        onChange={(e) => handleWorkModeChange(index, 'start', e.target.value)}
                      />
                    ))}
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="form-label passport-form-label" htmlFor="end1">Завершення роботи</label>
                  <div className="passport-stack-2">
                    {passportData.workModes.map((mode, index) => (
                      <input
                        key={index}
                        type="text"
                        className="form-control passport-form-control"
                        value={mode.end}
                        onChange={(e) => handleWorkModeChange(index, 'end', e.target.value)}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <div className="row g-3 mt-2 align-items-center">
                <div className="passport-label-col">
                  <label className="form-label passport-form-label m-0">Робочі дні</label>
                </div>
                <div className="passport-value-col">
                  <div className="passport-weekdays align-items-center">
                    {[
                      { id: 'wd1', day: 'monday', label: 'Пн' },
                      { id: 'wd2', day: 'tuesday', label: 'Вт' },
                      { id: 'wd3', day: 'wednesday', label: 'Ср' },
                      { id: 'wd4', day: 'thursday', label: 'Чт' },
                      { id: 'wd5', day: 'friday', label: 'Пт' },
                      { id: 'wd6', day: 'saturday', label: 'Сб' },
                      { id: 'wd7', day: 'sunday', label: 'Нд' }
                    ].map(({ id, day, label }) => (
                      <div key={id} className="form-check passport-form-check passport-form-check-inline">
                        <input
                          className="form-check-input passport-form-check-input"
                          type="checkbox"
                          id={id}
                          checked={passportData.workDays[day]}
                          onChange={(e) => handleWorkDayChange(day, e.target.checked)}
                        />
                        <label className="form-check-label passport-form-check-label" htmlFor={id}>
                          {label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="row g-3 mt-1 align-items-center">
                <div className="passport-label-col">
                  <label className="form-label passport-form-label m-0" htmlFor="holidays">Працює в свята</label>
                </div>
                <div className="passport-value-col">
                  <div className="passport-form-check">
                    <input
                      className="form-check-input passport-form-check-input"
                      type="checkbox"
                      id="holidays"
                      checked={passportData.worksOnHolidays}
                      onChange={(e) => handleInputChange('worksOnHolidays', e.target.checked)}
                    />
                    <label className="form-check-label passport-form-check-label" htmlFor="holidays">Так</label>
                  </div>
                </div>
              </div>

              
              <hr className="passport-my-4" />


              <div className="row g-3">
                <div className="col-12">
                  <label className="passport-section-title mb-3" htmlFor="manager">Опис</label>
                  <textarea
                    id="manager"
                    type="textarea"
                    rows={12}
                    className="form-control"
                    value={passportData.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                  />
                </div>
              </div>


              
              
              <hr className="passport-my-4" />

              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label passport-form-label" htmlFor="manager">Керівник</label>
                  <select
                    id="manager"
                    className="form-control passport-form-control"
                    value={passportData.managerEmployeeId || ''}
                    disabled={employeesLoading}
                    onChange={(e) => {
                      const employeeId = e.target.value;
                      const emp = employeesList.find(item => item._id === employeeId);
                      handleInputChange('managerEmployeeId', employeeId || null);
                      handleInputChange('manager', emp
                        ? [emp.lastName, emp.firstName, emp.middleName].filter(Boolean).join(' ')
                        : '');
                    }}
                  >
                    <option value="">{employeesLoading ? 'Завантаження...' : 'Оберіть директора зі списку працівників'}</option>
                    {employeesList.map(emp => (
                      <option key={emp._id} value={emp._id}>
                        {[emp.lastName, emp.firstName, emp.middleName].filter(Boolean).join(' ')}
                      </option>
                    ))}
                  </select>
                  {passportData.manager && !passportData.managerEmployeeId && (
                    <div className="form-text text-warning">
                      Поточний керівник («{passportData.manager}») ще не прив'язаний до картки працівника — оберіть його зі списку.
                    </div>
                  )}
                </div>
              </div>

              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label passport-form-label" htmlFor="manager">Надсилання запрошень</label>
                </div>
               
                <div className="passport-label-col"> {passportData.isOpen ? 'Садочок відкритий на прийом' : 'Садочок закритий на прийом'}</div>
                <button className="btn btn-primary passport-btn passport-btn-primary" onClick={handleCloseQueue}>
                  {passportData.isOpen ? 'Закрити на прийом' : 'Відкрити на прийом'}
                </button>
                
              </div>

              <div className="passport-mt-4">
                <button className="btn btn-primary passport-btn passport-btn-primary" onClick={handleSave}>
                  Зберегти зміни
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ZDOPassport;